'use client';

import { currentUrl } from '@dealerportal/utilities';
import { useEffect, useState } from 'react';

export const SourceInput = (props: any) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(currentUrl().href);
  }, []);

  return <input {...props} value={url} />;
};

export default SourceInput;
